export class AuthorizationModel {
  permission: string;
  permissions: string[];
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/permission/models/authorize.model.ts